import axios from "@/request";
import qs from "qs";
import stadium from "./stadium";

export default {
  async list(params: any) {
    return axios.get("admin/list", { params });
  },
  async detail(params: any) {
    return axios.get("admin/detail", { params });
  },
  async add(params: any) {
    return axios.post("admin/add", qs.stringify(params));
  },
  async edit(params: any) {
    return axios.post("admin/edit", qs.stringify(params));
  },
  async perms(params: any) {
    return axios.get("admin/admin-perms", { params });
  },
  async savePerms(params: any) {
    return axios.post("admin/save-admin-perms", qs.stringify(params));
  },
  async stadium(params: any) {
    return axios.get("admin/stadium", { params });
  },
  async savestadium(params: any) {
    return axios.post("admin/save-stadium", qs.stringify(params));
  },
  async permissions(params: any) {
    return axios.get("admin/permissions", { params });
  },
  async taisamAccounts(params: any) {
    return axios.get("admin/taisam-accounts", { params });
  },
  async addTaisamAccount(params: any) {
    return axios.post("admin/add-taisam-account", qs.stringify(params));
  },
  async editTaisamAccount(params: any) {
    return axios.post("admin/edit-taisam-account", qs.stringify(params));
  },
  async templatemessage(params: any) {
    return axios.get("admin/template-message", { params });
  },
  async roles(params: any) {
    return axios.get("admin/roles", { params });
  },
  async rolegroups(params: any) {
    return axios.get("admin/role-groups", { params });
  },
  async listtaisam(params: any) {
    return axios.get("admin/list-taisam", { params });
  },
  async deletetaisam(params: any) {
    return axios.post("admin/delete-taisam", qs.stringify(params));
  }
};
